import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { FaRegFolderOpen } from 'react-icons/fa';
import { MdArrowBack } from 'react-icons/md';
import { toast } from '../../toasts';
import { useNavigate } from 'react-router-dom';
import contractTemplateService from '../../services/contractTemplate.service';
import { getError } from '../../utils';
import { STANDALONE_EDITOR_PREFIX } from '../../constants/navigation';
import { EntityList, PageHead, Button, FormField, Section, Select, controlClass } from '../../components/EntityList';

const CATEGORIES = ['alquiler', 'venta', 'activo'];
const CATEGORY_LABELS = { alquiler: 'Alquiler', venta: 'Venta', activo: 'Activo' };

export default function ContractTemplateSetup() {
	const navigate = useNavigate();
	const [name, setName] = useState('');
	const [category, setCategory] = useState('alquiler');
	const [creating, setCreating] = useState(false);

	const goToList = () => navigate('/AdminScreen/Config/herramientas/plantillas');

	const handleOpen = async () => {
		if (!name.trim()) {
			toast.error('Complete el/los siguiente/s campo/s requerido/s: Nombre');
			return;
		}
		try {
			setCreating(true);
			const res = await contractTemplateService.create({ name: name.trim(), category });
			navigate(`${STANDALONE_EDITOR_PREFIX}/${res.data._id}`);
		} catch (err) {
			toast.error(getError(err));
		} finally {
			setCreating(false);
		}
	};

	return (
		<EntityList>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: 'Plantillas de contrato', to: '/AdminScreen/Config/herramientas/plantillas' },
					{ label: 'Nueva plantilla' },
				]}
				title='Nueva plantilla de contrato'
			/>
			<div className='tw:space-y-4'>
				<div className='tw:sticky tw:top-14 tw:z-20 tw:flex tw:flex-wrap tw:items-center tw:justify-between tw:gap-3 tw:rounded-panel tw:border tw:border-border tw:bg-surface/95 tw:px-5 tw:py-3.5 tw:shadow-sm tw:backdrop-blur'>
					<div className='tw:text-[12.5px] tw:text-ink-2'>Completá los datos para abrir el editor.</div>
					<div className='tw:flex tw:gap-2'>
						<Button icon={<MdArrowBack />} onClick={goToList} disabled={creating}>
							Cancelar
						</Button>
						<Button variant='primary' icon={<FaRegFolderOpen />} onClick={handleOpen} disabled={creating}>
							{creating ? 'Creando...' : 'Abrir editor'}
						</Button>
					</div>
				</div>
				<Section title='Nueva plantilla de contrato'>
					<div className='tw:grid tw:grid-cols-1 tw:gap-4 md:tw:grid-cols-2'>
						<FormField id='template-name' label='Nombre' required>
							<Form.Control
								id='template-name'
								className={controlClass}
								value={name}
								onChange={(e) => setName(e.target.value)}
								placeholder='Ej: Contrato de Alquiler Residencial'
								autoFocus
								onKeyDown={(e) => {
									if (e.key === 'Enter') handleOpen();
								}}
								disabled={creating}
							/>
						</FormField>
						<FormField id='template-category' label='Tipo' required>
							<Select
								id='template-category'
								options={CATEGORIES.map((c) => ({ value: c, label: CATEGORY_LABELS[c] }))}
								value={category}
								onChange={(e) => setCategory(e.target.value)}
								disabled={creating}
							/>
						</FormField>
					</div>
				</Section>
			</div>
		</EntityList>
	);
}
